import { type AxiosResponse } from 'axios'
import { type AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import {
  type IParamsGetContactsMessages,
  type IParamsGetHubspotWorkflows,
  type IResponseGetHubspotContactsStatistic,
  type IResponseGetHubspotWorkflowRefresh,
  type IResponseGetHubspotWorkflows,
  type IResponseHubspotWorkflow,
} from './types'

class Api {
  getHubspotWorkflows(
    params: IParamsGetHubspotWorkflows,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseGetHubspotWorkflows>> {
    return baseApi.post('analytics/analytics/hubspot-workflows', params, { ...options })
  }

  getHubspotWorkflowById(id: string): Promise<AxiosResponse<IResponseHubspotWorkflow>> {
    return baseApi.get(`analytics/analytics/hubspot-workflows/${id}`)
  }

  getHubspotWorkflowContactsMessages(
    id: string,
    params: IParamsGetContactsMessages
  ): Promise<AxiosResponse<IResponseGetHubspotContactsStatistic>> {
    return baseApi.get(`/hubspot-workflows/${id}/messages`, { params })
  }

  getHubspotWorkflowRefresh(
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseGetHubspotWorkflowRefresh>> {
    return baseApi.post('analytics/analytics/hubspot-workflows/refresh', null, options)
  }
}

export const HubspotWorkflowsApi = new Api()
